import { render, staticRenderFns } from "./devicesDashboard.vue?vue&type=template&id=45316c4d"
import script from "./devicesDashboard.vue?vue&type=script&lang=js"
export * from "./devicesDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports